export default __webpack_public_path__ + "static/media/axios.6d170f64.svg";